import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLensLayers, setLensLayers } from "../../slices/app";
export const useLensLayers = () => {
    const dispatch = useDispatch();
    const value = useSelector(getLensLayers);
    const update = useCallback((updatedValue) => {
        dispatch(setLensLayers(updatedValue));
    }, [dispatch]);
    return [value, update];
};
